import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface EmployerVerificationReceipt {
  verificationIds: number[];
  pendingIds: number[];
  signatureDataUrl: string | null;
  createdAt: string;
}

interface EmployerVerificationState {
  pricingAccepted: boolean;
  otpVerified: boolean;
  signatureDataUrl: string | null;
  receipt: EmployerVerificationReceipt | null;

  setPricingAccepted: (v: boolean) => void;
  setOtpVerified: (v: boolean) => void;
  setSignature: (dataUrl: string | null) => void;
  setReceipt: (receipt: EmployerVerificationReceipt | null) => void;
  reset: () => void;
}

const initial = {
  pricingAccepted: false,
  otpVerified: false,
  signatureDataUrl: null as string | null,
  receipt: null as EmployerVerificationReceipt | null,
};

/** Session-scoped state for the employer self-verification flow. */
export const useEmployerVerificationStore = create<EmployerVerificationState>()(
  persist(
    (set) => ({
      ...initial,
      setPricingAccepted: (v) => set({ pricingAccepted: v }),
      setOtpVerified: (v) => set({ otpVerified: v }),
      setSignature: (dataUrl) => set({ signatureDataUrl: dataUrl }),
      setReceipt: (receipt) => set({ receipt }),
      reset: () => set({ ...initial }),
    }),
    {
      name: 'tally:employer-verification',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
